import store from '@/store';

export default class ChatOnHoldEvent {
  constructor(body) {
    store.dispatch('channel/updateChatsOnHold', body.chatsOnHold);
  }
}
